import React from 'react';

export default function LoginFormHeader(props) {
    return (
        <div className="brand-gateway-form-header">
            <div className="brand-gateway-form-icon" />
            <div className="brand-gateway-form-subtitle">Log In to Get Started</div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./brand/login/form_header.js